import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form as FormikForm } from 'formik';
import * as Yup from 'yup';
import { Button } from '@material-ui/core';

import useSession from 'core/hooks/use-session';
import { FormField } from 'core/components/form';

import useStyles from './boats-form.styles';

export const validationSchema = Yup.object().shape({
  hullLength: Yup.number()
    .typeError('Hull length must be a number')
    .moreThan(0, 'Hull length must be greater than 0')
    .max(26, 'Hull length must be 26ft or less')
});

function AddBoat({ disabled, onAdd }) {
  const { viewOnly } = useSession();
  const classes = useStyles();

  return (
    <Formik
      initialValues={{ hullLength: '' }}
      validationSchema={validationSchema}
      validateOnBlur={false}
      onSubmit={(values, { resetForm, setFieldError, setFieldTouched, setSubmitting }) => {
        if (values.hullLength === '' || values.hullLength === null || values.hullLength === undefined) {
          setFieldTouched('hullLength', true, false);
          setFieldError('hullLength', 'Hull length is required');
          setSubmitting(false);
          return;
        }
        onAdd(Number(values.hullLength));
        resetForm();
      }}
    >
      {({ handleSubmit, isSubmitting, errors }) => (
        <FormikForm className={classes.addFormContainer} disabled={disabled || viewOnly}>
          <div className={classes.addRow}>
            <div className={classes.inputColumn}>
              <FormField
                id="hullLength"
                name="hullLength"
                type="numeric"
                label="Boat Hull length (ft.)"
                mode="dark"
                description={
                  errors.hullLength ? '' : 'A boat will be added by recording it’s hull length—max length is 26ft.'
                }
                descriptionClassName={classes.hint}
              />
            </div>
            <Button
              mode="big"
              variant="contained"
              color="secondary"
              className={classes.addButton}
              disabled={disabled || viewOnly || isSubmitting}
              onClick={handleSubmit}
            >
              Add boat
            </Button>
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}

AddBoat.propTypes = {
  disabled: PropTypes.bool,
  onAdd: PropTypes.func.isRequired
};

AddBoat.defaultProps = {
  disabled: false
};

export default AddBoat;
